// extracted by mini-css-extract-plugin
export default {"blockButtons":"BlockToggler_blockButtons__DE3pC"};